interface PhoneConfig {
  code: string;
  mask: (s: string) => string;
  placeholder: string;
  helpMessage?: string;

  length: number | { min: number; max: number };
}

export const phoneByCountry = {
  AR: {
    code: '+54',
    mask: (value) => value,
    length: { min: 10, max: 11 },
    placeholder: '9999999999999',
    helpMessage: 'Código de área con el 0, por ejemplo: 0 11',
  },

  UY: {
    code: '+598',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 8);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 2);

      if (numbers.length > 2) masked += ' ' + numbers.substring(2, 5);

      if (numbers.length > 5) masked += ' ' + numbers.substring(5, 8);

      return masked;
    },
    length: 8,
    placeholder: '99 999 999',
  },

  PY: {
    code: '+595',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 9);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 3);

      if (numbers.length > 3) masked += ' ' + numbers.substring(3, 9);

      return masked;
    },
    length: 9,
    placeholder: '999 999999',
  },

  CL: {
    code: '+56',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 9);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 1);

      if (numbers.length > 1) masked += ' ' + numbers.substring(1, 5);

      if (numbers.length > 5) masked += ' ' + numbers.substring(5, 9);

      return masked;
    },
    length: 9,
    placeholder: '9 9999 9999',
  },

  CO: {
    code: '+57',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 10);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 3);

      if (numbers.length > 3) masked += ' ' + numbers.substring(3, 6);

      if (numbers.length > 6) masked += ' ' + numbers.substring(6, 10);

      return masked;
    },
    length: 10,
    placeholder: '999 999 9999',
  },

  CR: {
    code: '+506',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 8);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 4);

      if (numbers.length > 4) masked += ' ' + numbers.substring(4, 8);

      return masked;
    },
    length: 8,
    placeholder: '9999 9999',
  },

  PE: {
    code: '+51',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 9);

      if (numbers.length === 0) return '';
      let masked = numbers.substring(0, 3);

      if (numbers.length > 3) masked += ' ' + numbers.substring(3, 6);

      if (numbers.length > 6) masked += ' ' + numbers.substring(6, 9);

      return masked;
    },
    length: 9,
    placeholder: '999 999 999',
  },

  GT: {
    code: '+502',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 8);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 4);

      if (numbers.length > 4) masked += ' ' + numbers.substring(4, 8);

      return masked;
    },
    length: 8,
    placeholder: '9999 9999',
  },

  PA: {
    code: '+507',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 8);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 4);

      if (numbers.length > 4) masked += ' ' + numbers.substring(4, 8);

      return masked;
    },
    length: 8,
    placeholder: '9999 9999',
  },

  BO: {
    code: '+591',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 8);

      return numbers;
    },
    length: 8,
    placeholder: '99999999',
  },

  MX: {
    code: '+52',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 10);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 2);

      if (numbers.length > 2) masked += '-' + numbers.substring(2, 6);

      if (numbers.length > 6) masked += '-' + numbers.substring(6, 10);

      return masked;
    },
    length: 10,
    placeholder: '99-9999-9999',
  },

  PR: {
    code: '+1',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 10);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 3);

      if (numbers.length > 3) masked += ' ' + numbers.substring(3, 6);

      if (numbers.length > 6) masked += ' ' + numbers.substring(6, 10);

      return masked;
    },
    length: 10,
    placeholder: '999 999 9999',
  },

  DO: {
    code: '+1',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 10);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 3);

      if (numbers.length > 3) masked += ' ' + numbers.substring(3, 6);

      if (numbers.length > 6) masked += ' ' + numbers.substring(6, 10);

      return masked;
    },
    length: 10,
    placeholder: '999 999 9999',
  },

  SV: {
    code: '+503',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 8);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 4);

      if (numbers.length > 4) masked += ' ' + numbers.substring(4, 8);

      return masked;
    },
    length: 8,
    placeholder: '9999 9999',
  },

  HN: {
    code: '+504',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 8);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 4);

      if (numbers.length > 4) masked += ' ' + numbers.substring(4, 8);

      return masked;
    },
    length: 8,
    placeholder: '9999 9999',
  },

  EC: {
    code: '+593',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 9);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 2);

      if (numbers.length > 2) masked += ' ' + numbers.substring(2, 5);

      if (numbers.length > 5) masked += ' ' + numbers.substring(5, 9);

      return masked;
    },
    length: 9,
    placeholder: '99 999 9999',
  },

  NI: {
    code: '+505',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 8);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 4);

      if (numbers.length > 4) masked += ' ' + numbers.substring(4, 8);

      return masked;
    },
    length: 8,
    placeholder: '9999 9999',
  },

  VE: {
    code: '+58',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 10);

      if (numbers.length === 0) return '';

      let masked = numbers.substring(0, 3);

      if (numbers.length > 3) masked += ' ' + numbers.substring(3, 10);

      return masked;
    },
    length: 10,
    placeholder: '999 9999999',
  },

  US: {
    code: '+1',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 10);

      if (numbers.length === 0) return '';

      let masked = '(' + numbers.substring(0, 3) + ')';

      if (numbers.length > 3) masked += ' ' + numbers.substring(3, 6);

      if (numbers.length > 6) masked += '-' + numbers.substring(6, 10);

      return masked;
    },
    length: 10,
    placeholder: '(999) 999-9999',
  },

  BR: {
    code: '+55',
    mask: (value) => {
      const numbers = value.replace(/\D/g, '').substring(0, 11);

      if (numbers.length === 0) return '';

      let masked = '(' + numbers.substring(0, 2);

      if (numbers.length > 2) {
        masked += ') ' + numbers.substring(2, 7);

        if (numbers.length > 7) masked += '-' + numbers.substring(7, 11);
      }

      return masked;
    },
    length: 11,

    placeholder: '(99) 99999-9999',
  },
} as Record<string, PhoneConfig>;
